/**
*
* RedSpeakersSpeaker
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { browserHistory } from 'react-router';

import setLanguageContent from 'helpers/setLanguageContent';
import cloneDeep from 'helpers/cloneDeep';

import authorImg from 'components/Templates/globalAssets/speakers/speakerblank.jpg';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import FullWithTextPlaceholder from 'components/Templates/commonStyles/FullWithTextPlaceholder';



class RedSpeaker extends React.PureComponent {
  constructor(){
    super();

    this.handlePrevSpeaker = this.handlePrevSpeaker.bind(this);
    this.handleNextSpeaker = this.handleNextSpeaker.bind(this);
    this.handleSpeakerToggle = this.handleSpeakerToggle.bind(this);

    this.state = {
      speakerData: '',
      prevSpeakerDisabled: false,
      nextSpeakerDisabled: false,
    }
  }

  handleSpeakerToggle(goBack) {

    const {
      speakers
    } = this.props;

    const {
      speakerData
    } = this.state;

    if (goBack) {
      this.setState({
        speakerData: cloneDeep(speakers[speakers.findIndex(speaker => speaker.speakerId === speakerData.speakerId) - 1 ])
      }, () => {
        this.handleHideShowArrows();
      });
    } else {
      this.setState({
        speakerData: cloneDeep(speakers[speakers.findIndex(speaker => speaker.speakerId === speakerData.speakerId) + 1 ])
      }, () => {
        this.handleHideShowArrows();
      });
    }
  }

  handlePrevSpeaker() { 
    this.handleSpeakerToggle(true);
  }

  handleNextSpeaker() { 
    this.handleSpeakerToggle();
  }

  handleHideShowArrows() {
    const {
      speakers
    } = this.props;

    const {
      speakerData
    } = this.state


  if (speakers && speakers.length && speakerData) {

    if (speakers.findIndex(speaker => speaker.speakerId === speakerData.speakerId) === 0) {
      this.setState({
        prevSpeakerDisabled: true,
      });
    } else {
      this.setState({
        prevSpeakerDisabled: false
      });
    }
  
    if (speakers.findIndex(speaker => speaker.speakerId === speakerData.speakerId) === speakers.length - 1) {
      this.setState({
        nextSpeakerDisabled: true,
      });
    } else {
      this.setState({
        nextSpeakerDisabled: false
      });
    }
  }
}

  componentDidMount() {



    const {
      commonProps,
      speakers,
    } = this.props;

    const {
      isEditor,
      isPreview,
      params
    } = commonProps;

    const {
      secondSlug
    } = params;

    let speakerData = '';

    for (let index = 0; index < speakers.length; index++) {
      const element = speakers[index];
      if (element.slug === secondSlug) {
        speakerData = element;
      }
    }

    if (!speakerData) speakerData = isEditor && speakers || speakers && isPreview ? speakers[0] : '';

    this.setState({
      speakerData: cloneDeep(speakerData)
    }, () => {
      this.handleHideShowArrows();
    });
  }

  componentDidUpdate(prevProps, prevState) {

    const {
      commonProps,
      speakers,      
    } = this.props;

    const {
      baseUrlTamplate,
      params,
      isEditor
    } = commonProps;

    const {
      secondSlug
    } = params;


    if (this.state.speakerData && secondSlug && this.state.speakerData.slug !== secondSlug && !isEditor) {
      if (!isEditor) {
        if (prevProps.commonProps.params.secondSlug !== secondSlug) {
          let speakerData = '';

          for (let index = 0; index < speakers.length; index++) {
            const element = speakers[index];
            if (element.slug === secondSlug) {
              speakerData = element;
            }
          }
      
          if (!speakerData) speakerData = isEditor && speakers || speakers && isPreview ? speakers[0] : '';
      
          return this.setState({
            speakerData: cloneDeep(speakerData)
          }, () => {
            this.handleHideShowArrows();
          });
        }
        browserHistory.push(`${baseUrlTamplate ? baseUrlTamplate : ''}/speaker/${this.state.speakerData && this.state.speakerData.slug ? this.state.speakerData.slug : ''}`);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
        
      };
    }


  }

  render() {


    const {
      speakerData,
      prevSpeakerDisabled,
      nextSpeakerDisabled
    } = this.state

    const {
      commonData,
      openEditor,
      commonProps,
      companyLogoType,
      speakers,
      presentations,
      language,
      agendaData
    } = this.props;

    const {
      sectionId
    } = commonData
 
    const {
      timezone,
      isEditor,
    } = commonProps;



    const placeholderWrapper = (placeholderContent) => (
      <FullWithTextPlaceholder>
        {placeholderContent}
      </FullWithTextPlaceholder>
    );

 
    
    if (!speakerData) return isEditor ? placeholderWrapper('Add at least one speaker to your event...') : placeholderWrapper('Missing Speaker...');

    const {
      speakerCompany
    } = speakerData;

    const thisCompanyLogoType = companyLogoType ? companyLogoType : 'colorLogo';

    const presentationsList = presentations ? presentations.map((presentation) => {
      const {
        dateFrom,
        dateTo
      } = presentation;

      let thisPresentation;

      if (!presentation.speakers || presentation.speakers.length < 1) return;
      for (let i = 0; i < speakers.length; i++) {
        if (presentation.speakers[i] === speakerData.speakerId) {




          if (!agendaData) return '';

          let hasPresentation;

          if (agendaData && agendaData.agenda) {
            const mapAgenda = agendaData.agenda.map((thisDay) => {
              if (thisDay.tracks) thisDay.tracks.map((thisTrack) => {
                if (thisTrack.presentations) thisTrack.presentations.map((thisTrackPresentation) => {
                  if (presentation.presentationId === thisTrackPresentation.presentationId) {
                    hasPresentation = true;
                  }
                });
              });
            });
          }
  


          if (!hasPresentation) continue;

          const start = moment(dateFrom).tz(timezone);


          const end = moment(dateTo).tz(timezone);

          thisPresentation = (

            <Wrapper
              {...commonProps}
              content={speakerData}
              typeOfStyle={'presentationWrapper'}
              
              editorData={
              {
                editorType: 'presentationWrapper',
                ...commonData
              }
            }
            key={'RedSpeaker-presentationWrapper'+speakerData.speakerId+'-'+sectionId+'-'+presentation.presentationId}
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'presentationTime'}
                editorData={
                  {
                    editorType: 'presentationTime',
                    ...commonData
                  }
                }
              >
                {`${start.format('DD MMMM YYYY HH:mm')} - ${end.format('HH:mm')}`}
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'presentationTitle'}
                editorData={
                  {
                    editorType: 'presentationTitle',
                    ...commonData
                  }
                }
              >
                {setLanguageContent(presentation, 'title', language)}
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'presentationDescription'}
                editorData={
                  {
                    editorType: 'presentationDescription',
                    ...commonData
                  }
                }
              >
                {setLanguageContent(presentation, 'description', language)}
              </Wrapper>
            </Wrapper>
          );
          break;
        }
      }

      return thisPresentation;
    }) : '';


    const presentationContent = (

      <Wrapper
        {...commonProps}
        content={speakerData}
        typeOfStyle={'presentationsWrapper'}
        
        editorData={
          {
            editorType: 'presentationsWrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          content={speakerData}
          typeOfStyle={'presentationsDetailsWrapper'}
          
          editorData={
              {
                editorType: 'presentationsDetailsWrapper',
                ...commonData
              }
            }
        >
          {presentationsList}
        </Wrapper>
      </Wrapper>
    );

    const speakerIcons = speakerData ? (
      <Wrapper
        {...commonProps}
        content={speakerData}
        typeOfStyle={'speakerIcons'}
        
        editorData={
          {
            editorType: 'speakerIcons',
            ...commonData
          }
        }
      >
      {
          speakerData.linkedin ? (
            <Wrapper
              {...commonProps}
              content={speakerData}
              typeOfStyle={'speakerLinkedinIcon'}
              href={speakerData.linkedin.startsWith('http') ? speakerData.linkedin : `https://${speakerData.linkedin}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerLinkedinIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

        {
          speakerData.facebook ? (
            <Wrapper
              {...commonProps}
              content={speakerData}
              typeOfStyle={'speakerFacebookIcon'}
              href={speakerData.facebook.startsWith('http') ? speakerData.facebook : `https://${speakerData.facebook}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerFacebookIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

        {
          speakerData.instagram ? (
            <Wrapper
              {...commonProps}
              content={speakerData}
              typeOfStyle={'speakerInstagramIcon'}
              href={speakerData.instagram.startsWith('http') ? speakerData.instagram : `https://${speakerData.instagram}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerInstagramIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

        {
          speakerData.twitter ? (
            <Wrapper
              {...commonProps}
              content={speakerData}
              typeOfStyle={'speakerTwitterIcon'}
              href={speakerData.twitter.startsWith('http') ? speakerData.twitter : `https://${speakerData.twitter}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerTwitterIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }
        {
          speakerData.website ? (
            <Wrapper
              {...commonProps}
              content={speakerData}
              typeOfStyle={'speakerWebIcon'}
              href={speakerData.website.startsWith('http') ? speakerData.website : `https://${speakerData.website}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerWebIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

      </Wrapper>
    ) : '';

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'horizontalMarginWrapper'}
          editorData={
          {
            editorType: 'horizontalMarginWrapper',
            ...commonData
          }
        }
        >
        {speakers && speakers.length ? (
          <Wrapper
            {...commonProps}
            content={speakerData}
            typeOfStyle={prevSpeakerDisabled ? 'prevSpeakerDisabled' : 'prevSpeaker'}
            
            handleClick={prevSpeakerDisabled ? null : this.handlePrevSpeaker}
            editorData={
              {
                editorType: prevSpeakerDisabled ? 'prevSpeakerDisabled' : 'prevSpeaker',
                ...commonData
              }
            }
          />) : ''}
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'speakerContainer'}
            editorData={
              {
                editorType: 'speakerContainer',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'speakerAvatar'}
              backgroundImage={speakerData.avatar ? speakerData.avatar : authorImg}
              editorData={
                {
                  editorType: 'speakerAvatar',
                  ...commonData
                }
              }
            >
            </Wrapper>
            {
              thisCompanyLogoType && speakerCompany && speakerCompany[thisCompanyLogoType] ? (
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'speakerLogoContainer'}
                  editorData={
                    {
                      editorType: 'speakerLogoContainer',
                      ...commonData
                    }
                  }
                >
                  <Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'speakerLogo'}
                    backgroundImage={speakerCompany[thisCompanyLogoType]}
                    editorData={
                      {
                        editorType: 'speakerLogo',
                        ...commonData
                      }
                    }
                  />
                </Wrapper>
              ) : ''
            }
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'speakerName'}
              editorData={
                {
                  editorType: 'speakerName',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                content={speakerData}
                typeOfStyle={'firstName'}
                
                editorData={
                {
                  editorType: 'firstName',
                  ...commonData
                }
              }
              />
              <Wrapper
                {...commonProps}
                content={speakerData}
                
                typeOfStyle={'lastName'}
                editorData={
                {
                  editorType: 'lastName',
                  ...commonData
                }
              }
            />
          </Wrapper>
          {
            speakerData.position ? (
              <Wrapper
                {...commonProps}
                typeOfStyle={'speakerJob'}
                
                editorData={
                  {
                    editorType: 'speakerJob',
                    ...commonData
                  }
                }
              >
                {speakerData ? speakerData.position : ''}
              </Wrapper>
              ) :''
            }
            {
              speakerCompany && speakerCompany.name ? (
                <Wrapper
                {...commonProps}
                typeOfStyle={'speakerComapny'}
                
                editorData={
                  {
                    editorType: 'speakerComapny',
                    ...commonData
                  }
                }
              >
                {speakerCompany ? speakerCompany.name : ''}
              </Wrapper>
              ) :''
            }
            {
              speakerData.description ? (
                <Wrapper
                  {...commonProps}
                  content={speakerData}
                  typeOfStyle={'speakerDescription'}
                  
                  editorData={
                    {
                      editorType: 'speakerDescription',
                      ...commonData
                    }
                  }
                >
                {setLanguageContent(speakerData, 'description', language)}
                </Wrapper>
              ) : ''
            }
            {speakerIcons}
          </Wrapper>
          {presentationContent}
          {speakers && speakers.length ? (
              <Wrapper
                {...commonProps}
                content={speakerData}
                typeOfStyle={nextSpeakerDisabled ? 'nextSpeakerDisabled' : 'nextSpeaker'}
                
                handleClick={nextSpeakerDisabled ? null : this.handleNextSpeaker}
                editorData={
                  {
                    editorType: nextSpeakerDisabled ? 'nextSpeakerDisabled' : 'nextSpeaker',
                    ...commonData
                  }
                }
              />
            ) : ''
          }
        </Wrapper>
      </Wrapper>
    );


  }
}

RedSpeaker.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  speakers: PropTypes.array,
  setShowPopup: PropTypes.func,
  defaultValues: PropTypes.object,
  thisSpeaker: PropTypes.object,
  speakerCompany: PropTypes.object,
};

export default RedSpeaker;
